var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.bodyHeight}),attrs:{"id":"error-page"}},[_c('h2',[_vm._v("没有网络吼~")]),_vm._v(" "),_c('p',[_vm._v("“不小心传回到80年代，网络信号是什么鬼？”")]),_vm._v(" "),_c('span',{on:{"click":_vm.refresh}},[_vm._v("刷新一下")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29836531","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = null
// module chunks = 